import { Box, Typography } from "@mui/material";
import React from "react";

import { primaryColor } from "theme";

const CustomIconButton = ({img, title, action, alt}) => {
  return (
    <Box
      sx={{
        border: "1px solid #3581E3",
        borderRadius: "4px",
        p: "5px 1rem",
        display: "flex",
        gap: ".5rem",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        cursor: "pointer"
      }}
      onClick={action}
    >
    <img src={img} alt={alt} />
      
      <Typography
        sx={{
          fontSize: "14px",
          color: primaryColor,
          textAlign: "center",
          fontWeight: 500
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default CustomIconButton;
